module.exports = __webpack_public_path__ + "img/2.7383aa73.jpg";